// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/assets/disclaimerassets/Disclaimer_BG-01.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.disclaimer-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  padding: 20px;
}

.disclaimer-container {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 5px 30px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 800px;
  overflow: hidden;
}

.logo {
  padding: 20px;
  text-align: center;
  background-color: #f8f9fa;
}

.logo img {
  max-width: 150px;
}

.disclaimer-content {
  padding: 30px;
}

.disclaimer-content h2 {
  margin-bottom: 20px;
  color: #2c3e50;
  text-align: center;
}

.disclaimer-text {
  max-height: 400px;
  overflow-y: auto;
  padding-right: 15px;
  margin-bottom: 30px;
  line-height: 1.6;
}

.disclaimer-text p {
  margin-bottom: 15px;
}

.disclaimer-text ol {
  padding-left: 20px;
  margin-bottom: 15px;
}

.disclaimer-text li {
  margin-bottom: 10px;
}

.disclaimer-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.accept-button, .decline-button {
  padding: 12px 30px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.accept-button {
  background-color: #3498db;
  color: white;
}

.accept-button:hover {
  background-color: #2980b9;
}

.decline-button {
  background-color: #f1f2f6;
  color: #7f8c8d;
}

.decline-button:hover {
  background-color: #e5e7eb;
}
`, "",{"version":3,"sources":["webpack://./src/components/Disclaimer.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yDAAkF;EAClF,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;EACzC,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".disclaimer-page {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background-image: url('../../public/assets/disclaimerassets/Disclaimer_BG-01.svg');\n  background-size: cover;\n  background-position: center;\n  padding: 20px;\n}\n\n.disclaimer-container {\n  background-color: white;\n  border-radius: 12px;\n  box-shadow: 0 5px 30px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  max-width: 800px;\n  overflow: hidden;\n}\n\n.logo {\n  padding: 20px;\n  text-align: center;\n  background-color: #f8f9fa;\n}\n\n.logo img {\n  max-width: 150px;\n}\n\n.disclaimer-content {\n  padding: 30px;\n}\n\n.disclaimer-content h2 {\n  margin-bottom: 20px;\n  color: #2c3e50;\n  text-align: center;\n}\n\n.disclaimer-text {\n  max-height: 400px;\n  overflow-y: auto;\n  padding-right: 15px;\n  margin-bottom: 30px;\n  line-height: 1.6;\n}\n\n.disclaimer-text p {\n  margin-bottom: 15px;\n}\n\n.disclaimer-text ol {\n  padding-left: 20px;\n  margin-bottom: 15px;\n}\n\n.disclaimer-text li {\n  margin-bottom: 10px;\n}\n\n.disclaimer-actions {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 20px;\n}\n\n.accept-button, .decline-button {\n  padding: 12px 30px;\n  border: none;\n  border-radius: 6px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.accept-button {\n  background-color: #3498db;\n  color: white;\n}\n\n.accept-button:hover {\n  background-color: #2980b9;\n}\n\n.decline-button {\n  background-color: #f1f2f6;\n  color: #7f8c8d;\n}\n\n.decline-button:hover {\n  background-color: #e5e7eb;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
